import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { ReturnFiledProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/ReturnFiledProgressionActions'

export interface ReturnFiledProgressionActionsContainerProps {
  vm: JobProgressionViewModel
  jobVm: JobDetailsViewModel
  canCompleteJob?: boolean
}

export const ReturnFiledProgressionActionsContainer = observer(
  function ReturnFiledProgressionActionsContainer({
    vm,
    jobVm,
    canCompleteJob,
  }: ReturnFiledProgressionActionsContainerProps) {
    return (
      <ReturnFiledProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        canCompleteJob={canCompleteJob}
        pendingActionsText={jobVm.scopeChangesVm.pendingActionsText}
        onCompleteJob={vm.closeJob}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} />
          )
        }
      />
    )
  },
)
